module.exports = __webpack_public_path__ + "static/media/ExamIcon.3b23c099.svg";